import script from "./PlotCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlotCards.vue?vue&type=script&setup=true&lang=ts"

import "./PlotCards.vue?vue&type=style&index=0&id=5f59dd06&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f59dd06"]])

export default __exports__